import { useMemo } from 'react'

import { FLAGS, useFeatureFlag } from '@/lib/hooks/useFeatureFlag'
import { useLoadServices } from '@/lib/queries/Services.queries'
import { Service } from '@/lib/definitions/api.types'
import {
  INSIGHTS_PRODUCTS,
  countActiveIpTransitServices,
} from '@/lib/misc/insightsEligibility'

export const useInsightsOpensExternally = (): boolean => {
  const isBenocsEnabled = useFeatureFlag(FLAGS.BENOCS)
  const hasIdentityProvider = useFeatureFlag(FLAGS.IDENTITY_PROVIDER)

  const { data } = useLoadServices(
    { productId: INSIGHTS_PRODUCTS },
    { enabled: isBenocsEnabled && hasIdentityProvider }
  )

  return useMemo(
    () => countActiveIpTransitServices(data as Service[] | undefined) > 0,
    [data]
  )
}
